/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { getImageAtSize } from '../../lib/utils';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/blocks/prizes.module.scss';

const propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            body: PropTypes.string,
        }),
    ),
    imageSize: PropTypes.string,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    description: null,
    items: [],
    imageSize: 'medium',
    className: null,
    isContainer: false,
    containerClassName: null,
};

function PrizesBlock({
    title,
    description,
    items,
    imageSize,
    className,
    isContainer,
    containerClassName,
}) {
    const themeClassName = useThemeClassName(styles);
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {title !== null ? (
                    <h4 className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
                ) : null}
                <div className={styles.items}>
                    {items.map(({ name: itemName = null, image = null }) => {
                        const {
                            width = 0,
                            height = 0,
                            url: imageUrl,
                        } = getImageAtSize(image, imageSize, false);
                        const hasSize = width !== 0 && height !== 0;
                        return (
                            <div className={styles.item}>
                                {imageUrl !== null ? (
                                    <div className={styles.imageContainer}>
                                        <img
                                            className={styles.image}
                                            src={imageUrl}
                                            alt="Prize"
                                            width={hasSize ? width : null}
                                            height={hasSize ? height : null}
                                        />
                                    </div>
                                ) : null}
                                {itemName !== null ? (
                                    <div
                                        className={styles.text}
                                        dangerouslySetInnerHTML={{ __html: itemName }}
                                    />
                                ) : null}
                            </div>
                        );
                    })}
                </div>
                {description !== null ? (
                    <div
                        className={styles.description}
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                ) : null}
            </div>
        </div>
    );
}

PrizesBlock.propTypes = propTypes;
PrizesBlock.defaultProps = defaultProps;

export default PrizesBlock;
